<template>
	<div>
		<Tou></Tou>
		<div class="webinar-banner mt-51 pb-50">
			<div class=" webinar-banner1">
				<el-carousel ref="carousel" :autoplay="false" :height="contentHeight + 'px'" :interval="3000"
					indicator-position="none" arrow="always">
					<el-carousel-item v-for="(l, i) in resoulie" ref="bannerheight">
						<div class="bj-0 flex  webinar-banner-neirongs">
							<div class="webinar-banner-tu br-20 mt-44  ml-46 mb-49" style="position: relative;" @click="xiangqing(l.id)">
								<el-image :src="l.image" fit="" />
								<div style="position: absolute;top: 0;left:0"
									class="zhezhaos t-center a-center cur_pointer">
									<div class="iconfont icon-play ys-0 f-60"></div>
								</div>
							</div>
							<div class="ml-73 mt-60 mb-30  webinar-banner-neirong" @click="xiangqing(l.id)">
								<div class="tit-16 z-A0A0A0 B-300 montserLight">{{ l.riqi }}</div>
								<div class="tit-26 ys-33 B-500 mt-20 mb-35 shengluhao2 montserMedium" >{{ l.title }}
								</div>
								<div class="tit-18 ys-66 mt-35 B-300 webinar-banner-name shengluhao2 montserLight">{{
									l.remark }}</div>
								<div @click="xiangqing(l.id)" class="webinar-banner-btn ys-0 mt-44 pt-21 pb-22 pl-39 pr-57 more1">
									<span class="mr-12 montserLight cur_pointer">Start</span>
									<span class="iconfont icon-arrow-right"></span>
								</div>
							</div>
						</div>
					</el-carousel-item>

<!-- 
					<el-carousel-item v-for="(l, i) in resoulie" ref="bannerheight">
						<div class="bj-0 flex  webinar-banner-neirongs">
							<div class="webinar-banner-tu br-20 mt-44  ml-46 mb-49" style="position: relative;">
								<el-image :src="l.image" fit="" />
								<div style="position: absolute;top: 0;left:0"
									class="zhezhaos t-center a-center cur_pointer">
									<div class="iconfont icon-play ys-0 f-60"></div>
								</div>
							</div>
							<div class="ml-73 mt-60 mb-30  webinar-banner-neirong">
								<div class="tit-16 z-A0A0A0 B-300 montserLight">{{ l.riqi }}</div>
								<div class="tit-26 ys-33 B-500 mt-20 mb-35 shengluhao2 montserMedium">{{ l.title }}
								</div>
								<div class="tit-18 ys-66 mt-35 B-300 webinar-banner-name shengluhao2 montserLight">{{
									l.contan }}</div>
								<div class="webinar-banner-btn ys-0 mt-44 pt-21 pb-22 pl-39 pr-57 more1">
									<span class="mr-12 montserLight">Start</span>
									<span class="iconfont icon-arrow-right"></span>
								</div>
							</div>
						</div>
					</el-carousel-item> -->


				</el-carousel>
			</div>
		</div>
		<div class="webinar-listbox w100 bj-0">
			<div class="w1500">
				<div class="pt-74 flex j-between box">
					<div class="webinar-sign b-F6F6F8">
						<el-form ref="form" :model="so" label-width="0px">
							<el-form-item>
								<div class="flex j-between">
									<div class="flex">
										<div class="iconfont icon-sousuo pl-20" style="color:#717172">
										</div>
										<el-input class="resou_souinput" v-model="so.keywords"
											:placeholder="gudingziduan.resource.sousuo1" placeholder-class="tit-16"
											placeholder-style="color:#757575;" @blur="send" ></el-input>

									</div>
									<div class="btn cur_pointer t-center tit-15 montserLight" @click="send">Search</div>
								</div>
							</el-form-item>
						</el-form>
					</div>
					<div class="webinar-sign2 flex j-end">
						<div class="rel ml-18  casca" v-if="xuanlei == 1">
							<span class="iconfont icon-earth abs f-20 h100" style="z-index: 1;color: #6b6b6b;"></span>
							<el-cascader popper-class="cascass" class="abs" :options="yuyan2" :placeholder="gudingziduan.resource.videoLanguage"
								:props="{ multiple: true, checkStrictly: true }" clearable collapse-tags  @change="xuanyuyans">
							</el-cascader>
						</div>
						<div class="rel ml-18  casca" v-if="xuanlei == 1">
							<span class="iconfont icon-chanpinleixing abs f-20 h100"
								style="z-index: 1;color: #6b6b6b;"></span>
							<el-cascader popper-class="cascass" class="abs" :options="Ptype" :placeholder="gudingziduan.resource.videoProduct"
								:props="{ multiple: true, checkStrictly: true }" clearable collapse-tags @change="xuanproduct">
							</el-cascader>
						</div>
						<div class="rel ml-18  casca" v-if="xuanlei == 1">
							<span class="iconfont icon-chanpinleixing abs f-20 h100"
								style="z-index: 1;color: #6b6b6b;"></span>
							<el-cascader popper-class="cascass" class="abs" :options="type" :placeholder="gudingziduan.resource.videoType"
								:props="{ multiple: true, checkStrictly: true }" clearable collapse-tags @change="xuanleixin">
							</el-cascader>
						</div>
						<div class="rel ml-18  casca" v-if="xuanlei == 2">
							<span class="iconfont icon-earth abs f-20 h100" style="z-index: 1;color: #6b6b6b;"></span>
							<el-cascader popper-class="cascass" class="abs" :options="country" :placeholder="gudingziduan.resource.videoCountry"
								:props="{ multiple: false, checkStrictly: true }" clearable  collapse-tags @change="xuanguojia">
							</el-cascader>
						</div>
						<div class="rel ml-18  casca" v-if="xuanlei == 2">
							<span class="iconfont icon-earth abs f-20 h100" style="z-index: 1;color: #6b6b6b;"></span>
							<el-cascader popper-class="cascass" class="abs" :options="yuyan" :placeholder="gudingziduan.resource.videoLanguage"
								:props="{ multiple: true, checkStrictly: true }" clearable collapse-tags  @change="xuanyuyans">
							</el-cascader>
						</div>
					</div>
				</div>
				<!-- <el-divider></el-divider> -->
				<div class="w100 flex video-biaoqian mb-32">
					<div class="video-biaoqian-item tit-15 ys-33 cur_pointer montserLight"
						:class="xuanlei == 2 ? 'xactive' : ''" @click="Xuanleis(2)">
						<!-- Playlists -->
						{{gudingziduan.resource.videoPlaylists}}
						
						</div>
					<div class="video-biaoqian-item tit-15 ys-33 cur_pointer montserLight"
						:class="xuanlei == 1 ? 'xactive' : ''" @click="Xuanleis(1)">Video</div>
				</div>
				<div class="pb-42">
					<ul class="flex-wrap flex " v-if="xuanlei == 1">
						<li class="video-goods video-goodss cur_pointer mb-40" v-for="(s, i) in goods"
							@click="xiangqing(s.id)">
							<div style="position: relative;">
								<img class="cptus" :src="s.image" />
								<div style="position: absolute;top: 0;left:0"
									class="zhezhaos t-center a-center cur_pointer">
									<div class="iconfont icon-play ys-0 f-60"></div>
								</div>
								<div class="video-jiaobiao">
									<span class="ys-0 tit-15 ">{{ s.videoTime }} </span>
								</div>
							</div>
							<div class="pt-38 pr-28 pb-40 pl-25 webinar-goodbox">
								<div class="tit-20 ys-33 mb-19 B-300 resouname montserRegular">{{ s.title }}</div>
								<div class="ys-66 mb-19 B-300 shengluhao2" style="word-break: break-all">{{ s.remark }}</div>
								<div class="B-300 time">{{ s.createTime }}</div>
							</div>
						</li>
					</ul>
					<ul class="flex-wrap flex " v-if="xuanlei == 2">
						<li class="video-goods-playlists cur_pointer mb-68" v-for="(s, i) in Playlistshu"
							@click="xiangqing2(s.id)">
							<div class="video-goods video-goods-list" style="z-index:3;">
								<div style="position: relative;">
									<img class="cptus" :src="s.image" />
									<div style="position: absolute;top: 0;left:0"
										class="zhezhaos t-center a-center cur_pointer">
										<div class="iconfont icon-play ys-0 f-60"></div>
									</div>
									<div class="video-jiaobiao">
										<img :src="require('@/assets/pc/resouce/bofanlie.png')" alt="">
										<span class="ys-0 tit-15 ml-6 mr-6">{{ s.videoCount }} </span>
										<span class="ys-0 tit-15  ml-6 mr-6">videos</span>
									</div>
								</div>
								<div class="pt-38 pr-28 pb-40 pl-25 webinar-goodbox">
									<div class="tit-20 ys-33 mb-19 B-300 resouname montserRegular">{{ s.title }}</div>
									<div class="tit-16 ys-66 B-300">
										<!-- View full playlist -->
										{{gudingziduan.resource.videofullplaylist}}
									</div>
								</div>
							</div>
							<div class="card card2"></div>
							<div class="card card3"></div>
						</li>
					</ul>
				</div>
				<el-pagination class="flex j-center pb-108" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" :current-page.sync="sos.ye" :page-size="sos.jitiao"
					layout="prev, pager, next, jumper,slot" :total="zongshu" :pager-count="3">
					<span class="ml-10 cur_pointer" @click="goToPage">go</span>
				</el-pagination>

			</div>
		</div>
		<div class="StayMain">
			<StayTact></StayTact>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
import Tou from '../../../zuzuzu/touss2.vue'
import StayTact from '../../../components/StayTact.vue'
import Foot from '../../../zuzuzu/foot.vue'
import { videotype, Tyvideolie,Playlist,Guojias,Yuyanlies,videocptype,videotop} from '@/api/resource.js';
export default {
	data() {
		return {
			resoulie: [
		// 		{ tu: 'https://goodwe.hnydl.com.cn/gongyong/shangchuan/tu/33/2024/11/b8SQBWc7yzu7K4WSYCy3ZCYSc73QYK.png', riqi: '2024.10.14', title: 'GoodWe Lithium Battery Solutions For Advanced Residential Energy Storage', contan: 'This webinar will provide valuable insights into our cutting-edge lithium battery solutions, showcasing how they can support and improvevaluable insights into our cutting-edge lithium battery solutions, showcasing how they can support and improve' },
		// 		{ tu: 'https://www.goodwe.com/Public/Uploads/uploadfile/images/20241114/liebiaoye.jpg', riqi: '2024.09.15', title: 'Comparativo de custos entre Galaxy GoodWe e módulos convencionais ', contan: 'This webinar will provide valuable insights into our cutting-edge lithium battery solutions, showcasing how they can support and improve valuable insights into our cutting-edge lithium battery solutions, showcasing how they can support and improve' },
		// 		{ tu: 'https://www.goodwe.com/Public/Uploads/uploadfile/images/20240926/20240926-151929.jpg', riqi: '2024.09.15', title: 'GoodWe PLUS+ Pakistan: Energizing Installers with our Attractive Loyalty Program and Training Series', contan: 'This webinar will provide valuable insights into our cutting-edge lithium battery solutions, showcasing how they can support and improve valuable insights into our cutting-edge lithium battery solutions, showcasing how they can support and improve' },
		
			],
			goods: [
				// { botime: '23:45', videonum: 20, tu: 'https://goodwe.hnydl.com.cn/gongyong/shangchuan/tu/33/2024/11/b8SQBWc7yzu7K4WSYCy3ZCYSc73QYK.png', riqi: '2024.10.14', title: 'GoodWe Lithium Battery Solutions For Advanced Residential Energy Storage', contan: 'This webinar will provide valuable insights into our cutting-edge lithium battery solutions, showcasing how they can support and improvevaluable insights into our cutting-edge lithium battery solutions, showcasing how they can support and improve' },
				// { botime: '23:45', videonum: 20, tu: 'https://www.goodwe.com/Public/Uploads/uploadfile/images/20241114/liebiaoye.jpg', riqi: '2024.09.15', title: 'Comparativo de custos entre Galaxy GoodWe e módulos convencionais ', contan: 'This webinar will provide valuable insights into our cutting-edge lithium battery solutions, showcasing how they can support and improve valuable insights into our cutting-edge lithium battery solutions, showcasing how they can support and improve' },
				// { botime: '23:45', videonum: 20, tu: 'https://www.goodwe.com/Public/Uploads/uploadfile/images/20240926/20240926-151929.jpg', riqi: '2024.09.15', title: 'GoodWe PLUS+ Pakistan: Energizing Installers with our Attractive Loyalty Program and Training Series', contan: 'This webinar will provide valuable insights into our cutting-edge lithium battery solutions, showcasing how they can support and improve valuable insights into our cutting-edge lithium battery solutions, showcasing how they can support and improve' },
				// { botime: '23:45', videonum: 20, tu: 'https://www.goodwe.com/Public/Uploads/uploadfile/images/20240926/20240926-151929.jpg', riqi: '2024.09.15', title: 'GoodWe PLUS+ Pakistan: Energizing Installers with our Attractive Loyalty Program and Training Series', contan: 'This webinar will provide valuable insights into our cutting-edge lithium battery solutions, showcasing how they can support and improve valuable insights into our cutting-edge lithium battery solutions, showcasing how they can support and improve' },
				// { botime: '23:45', videonum: 20, tu: 'https://www.goodwe.com/Public/Uploads/uploadfile/images/20241114/liebiaoye.jpg', riqi: '2024.09.15', title: 'Comparativo de custos entre Galaxy GoodWe e módulos convencionais ', contan: 'This webinar will provide valuable insights into our cutting-edge lithium battery solutions, showcasing how they can support and improve valuable insights into our cutting-edge lithium battery solutions, showcasing how they can support and improve' },
				// { botime: '23:45', videonum: 20, tu: 'https://www.goodwe.com/Public/Uploads/uploadfile/images/20240926/20240926-151929.jpg', riqi: '2024.09.15', title: 'GoodWe PLUS+ Pakistan: Energizing Installers with our Attractive Loyalty Program and Training Series', contan: 'This webinar will provide valuable insights into our cutting-edge lithium battery solutions, showcasing how they can support and improve valuable insights into our cutting-edge lithium battery solutions, showcasing how they can support and improve' },
				// { botime: '23:45', videonum: 20, tu: 'https://www.goodwe.com/Public/Uploads/uploadfile/images/20240926/20240926-151929.jpg', riqi: '2024.09.15', title: 'GoodWe PLUS+ Pakistan: Energizing Installers with our Attractive Loyalty Program and Training Series', contan: 'This webinar will provide valuable insights into our cutting-edge lithium battery solutions, showcasing how they can support and improve valuable insights into our cutting-edge lithium battery solutions, showcasing how they can support and improve' },

			],
			yuyan: [
			// 	{
			// 	label: 'English',
			// 	value: 'EN'
			// }, {
			// 	label: 'Deutsch',
			// 	value: 'DN'
			// }, {
			// 	label: 'Español',
			// 	value: 'ENS'
			// },
			],
			yuyan2: [
			],
			country:[],
			Language:'',
			type: [{ label: 'Introduction', value: '1' }, { label: 'Installation', value: '2' }, { label: 'Commissioning', value: '3' }, { label: 'Monitoring', value: '4' }, { label: 'Trouble shooting', value: '5' }, { label: 'Solution', value: '6' }, { label: 'Webinar replay', value: '7' }],
			Ptype:[],
			xuanyuyan: '',
			bannerheight: '',
			wanebgsty: '',
			screenWidth: '',
			contentHeight: '',
			xianshiyuyan: false,
			xianshiyuyan2: false,
			so: {},
			sos: { ye: 1, jitiao:9},
			zongshu: 30,
			targetPage: '',
			xuanlei:2,
			Playlistshu:[],
			gudingziduan:{}
		}
	},
	components: {
		Tou,
		StayTact,
		Foot
	},
	watch: {
	    '$store.state.cunyuanyan': {
	      handler(newValue, oldValue) {
	        // console.log('语言已更新:', newValue);
	        this.gudingziduan=this.$store.state.cunyuanyan
			// console.log(this.gudingziduan,'video')
	      },
	      deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
	    }
	},
	created: function () {
		this.$cun('Tindex',1)
		this.$cun('Menuindex',0)
		this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
		this.gudingziduan=this.$store.state.cunyuanyan
		// console.log(this.gudingziduan,'video2')
		
		videotop({'pageNum':0,'pageSize':6}).then(shu=>{
			this.resoulie=shu.data
		})
		videotype().then(shu => {
			if (shu.code == 200) {
				 this.type = shu.data.map(item => {  
				  return {  
					...item, // 保留原对象的所有属性  
					label: item.name ,// 添加 label 属性，您可以根据需要设置标签内容  
					value: item.id
				  };  
				});  
				// console.log( this.type)
			}
		})
		Guojias().then(s=>{
			if (s.code == 200) {
				 this.country = s.data.map(item => {  
				  return {  
					...item, // 保留原对象的所有属性  
					label: item.country ,// 添加 label 属性，您可以根据需要设置标签内容  
					value: item.country,
				  };  
				});  
			}
		})
		Yuyanlies().then(shu=>{
			if(shu.data && shu.data.length>0){
				this.yuyan2 = shu.data.map(item => {
				  return {  
					...item, // 保留原对象的所有属性  
					label: item.name ,// 添加 label 属性，您可以根据需要设置标签内容  
					value: item.name
				  };  
				}); 
			}
		})
		videocptype().then(s=>{
			if (s.code == 200) {
				 this.Ptype = s.data.map(item => {  
				  return {  
					...item, // 保留原对象的所有属性  
					label: item.name ,// 添加 label 属性，您可以根据需要设置标签内容  
					value: item.id
				  };  
				});  
			}
		})
		this.playlistlies()
	},
	mounted() {
		// this.adjustCarouselHeight();
		    // 模拟异步获取数据
		setTimeout(() => {
		  this.adjustCarouselHeight();
		}, 1000); 
		window.addEventListener('resize', this.adjustCarouselHeight); // 添加窗口调整大小的事件监听  
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.adjustCarouselHeight); // 清理事件监听  
	},
	methods: {
		xiangqing(id){
			this.$router.push({
				name: 'video-details',
				params: { id: id }
			})
			// $dakai('video-details?id='+l.id)
		},
		xiangqing2(id) {
			this.$router.push({
				name: 'Playlists-details',
				params: { id: id }
			})
			// $dakai('Playlists-details?id=' + s.id)
		},
		playlistlies(){
			Playlist({ "pageNum": 0,"pageSize":9,"language":this.sos.language,"country":this.sos.country}).then(shu=>{
				this.Playlistshu=shu.data.content
				this.zongshu=shu.data.totalPages
			})
		},
		videolies(){
			Tyvideolie({'pageNum':this.sos.ye-1,'pageSize':9,"type":this.sos.type,"keyword":this.so.keywords,'language':this.sos.language,"proType":this.sos.prоType}).then(shu => {
				// console.log(shu)
				if (shu.code == 200) {
					this.goods=shu.data.content
					this.zongshu=Number(shu.data.totalElements)
				}
			})
		},
		adjustCarouselHeight() {
		  this.$nextTick(() => {
		    setTimeout(() => {
		      const carousel = this.$refs.carousel;
		      if (carousel) {
		        // 遍历 resoulie 数组
		        for (let i = 0; i < this.resoulie.length; i++) {
		          const itemData = this.resoulie[i];
		          // 检查 image 是否有值
		          if (itemData && itemData.image) {
		            // 获取当前轮播项元素，假设 ref="bannerheight" 能唯一标识轮播项
		            const carouselItem = this.$refs.bannerheight[i];
		            if (carouselItem) {
		              // 在当前轮播项内查找.webinar-banner-neirongs 元素
		              const contentContainer = carouselItem.$el.querySelector('.webinar-banner-neirongs');
		              if (contentContainer) {
		                this.contentHeight = contentContainer.offsetHeight;
		                carousel.$el.style.height = `${this.contentHeight}px`;
		                // 找到合适的元素后跳出循环
		                break; 
		              }
		            }
		          }
		        }
		      }
		    }, 100);
		  });
		},
		// adjustCarouselHeight() {
		// 	this.$nextTick(() => {
		// 		setTimeout(() => {
		// 			const carousel = this.$refs.carousel; // 获取轮播图的引用 
		// 			const contentContainer = carousel.$el.querySelector('.webinar-banner-neirongs'); // 获取白色部分 
		// 			console.log(contentContainer)
		// 			if (carousel && contentContainer) {
		// 				this.contentHeight = contentContainer.offsetHeight; // 获取白色部分的高度 
		// 				carousel.$el.style.height = `${this.contentHeight}px`; // 设置轮播图的高度 
		// 			}
		// 		}, 100); // 延迟设为 0 毫秒 
		// 	});
		// },
		Xuanleis(e) {
			this.xuanlei = e
			if(e==1){
				this.videolies()
			}else{
				this.playlistlies()
			}
		},
		Yuyans() {
			this.xianshiyuyan = !this.xianshiyuyan
		},
		Types() {
			this.xianshiyuyan2 = !this.xianshiyuyan2
		},
		send() {
			this.videolies()
		},
		Yuyanxuan(e) {

		},
		Typexuan(e) {
			Tyvideolie(e).then(shu => {
				// console.log(shu)
				if (shu.code == 200) {
					this.so.keywords = shu.data
				}
			})
		},
		xuanleixin(e){//视频分类筛选
			// console.log(e)
			let types=''
			for(let i in e){
				 types+=e[i][0]+','
			}
			this.sos.type=types.substring(0,types.length - 1) 
			this.videolies()
		},
		xuanproduct(e){//视频分类筛选
			// console.log(e)
			let products=''
			for(let i in e){
				 products+=e[i][0]+','
			}
			this.sos.prоType=products.substring(0,products.length - 1) 
			this.videolies()
		},
		
		xuanyuyans(e){
			// let language=[]
			// for(let i in e){
			// 	 language[]=e[i][0]
			// }
			this.sos.language=e.flat();
			// this.sos.language=language.substring(0,language.length - 1) 
			if(this.xuanlei ==1){
				this.videolies()
			}else{
				this.playlistlies()
			}
		},
		xuanguojia(e){
			let country=''
			let cindex=''
			e.forEach(value => {  
				cindex= this.country.findIndex(option => option.value === value); // 假设选项对象中有 'value' 属性  
				// console.log('选择的下标:', cindex);  
			}); 
			this.sos.country=e[0]
			if(cindex>=0){
				this.yuyan=this.country[cindex].languages
				this.yuyan =this.yuyan.map(item => {
				  return {  
					...item, // 保留原对象的所有属性  
					label: item.name ,// 添加 label 属性，您可以根据需要设置标签内容  
					value: item.name
				  };  
				});  
			}
			// console.log('选择的下标语言列:', this.yuyan);
			this.playlistlies()
			// console.log(this.sos.country)
		},
		guajias(e){
			// console.log(e)
		},
		handleCurrentChange(e) {
			// console.log(e)
			this.so.pageNum=e-1
			this.so.pageSize=9
			Tyvideolie(this.so).then(shu => {
				// console.log(shu)
				if (shu.code == 200) {
					this.goods=shu.data.content
				}
			})
		},
		handleSizeChange(e) {
		},
		goToPage() {
			this.handleCurrentChange(this.sos.ye)
		}
	},
}
</script>

<style lang="scss" scoped>
.b-F6F6F8 {
	background: #F6F6F8;
}

.z-8E8E8E {
	color: #8E8E8E;
}

.video-goods-playlists {
	display: flex;
	position: relative;
	width: 31.3%;
	
	.video-goods {
		width: 100%;
	}
}
.video-goods-playlists:not(:nth-child(3n)){
	margin-right: .4rem;
}
.card-container {
	display: flex;
	justify-content: center;
	position: relative;
	/* 使得子元素可以绝对定位 */
	height: 300px;
	/* 设置容器高度以避免重叠造成的影响 */
}


.webinar-banner-neirongs {
	overflow: hidden;
	border-radius: 10px;
	width: 85.6%;
	margin: 0 auto;
}

.video-jiaobiao {
	opacity: 0.6;
	background: #000000;
	border-radius: 3px;
	display: inline-block;
	padding: .05rem .1rem .05rem .1rem;
	position: absolute;
	right: 11px;
	bottom: 12px;

	img {
		width: .14rem !important;
		height: .12rem !important;
	}
}

.card {
	background-color: white;
	border-radius: 10px;
	// box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);  
	overflow: hidden;
	text-align: center;
	position: absolute;
	/* 使用绝对定位 */
	transition: transform 0.3s;
	/* 添加过渡效果 */
}

.card2 {
	// width:260;
	left: .12rem;
	height: .2rem;
	bottom: -0.1rem;
	/* 向下移动一定距离以实现重叠效果 */
	z-index: 2;
	/* 确保第二张卡片在下层 */
	background: #D2D2D2;
	// width: 4.51rem;
	width: 95%;
}

.card3 {
	width: 92%;
	height: .2rem;
	left: .17rem;
	bottom: -0.2rem;
	/* 向下移动一定距离以实现重叠效果 */
	z-index: 1;
	/* 确保第二张卡片在下层 */
	background: #A9A9A9;
}

// =====================4
.webinar-banner {
	.z-A0A0A0 {
		color: #A0A0A0;
	}

	.webinar-banner1 {
		width: 91%;
		margin: .51rem auto 0rem auto;

		::v-deep .el-carousel__arrow--left,
		::v-deep .el-carousel__arrow--right {
			background-color: #FFFFFF !important;
			color: #333;
			width: .66rem;
			height: .66rem;
			font-size: .24rem;

			&:hover {
				background: red !important;

				i {
					color: #fff;
				}
			}
		}

		::v-deep .el-icon-arrow-left:before {
			content: "\e6ea";
		}

		::v-deep .el-icon-arrow-right:before {
			content: "\e6e9";
		}

	}

	.webinar-banner-tu {
		width: 39.6%;
		border-radius: 10px;
		overflow: hidden;

		.el-image {
			width: 100%;
			height: 100%;
			border-radius: 10px;

			img {
				object-fit: cover;
			}
		}
	}

	.webinar-banner-tu:hover {
		.zhezhaos::after {
			height: 100%;
		}

		.icon-play {
			transition-delay: .3s;
			opacity: 1;
		}
	}

	.webinar-banner-neirong {
		width: 43%;

		.webinar-banner-btn {
			display: inline-flex;
			align-items: center;
			padding: .15rem .3rem .15rem .39rem;
			background: linear-gradient(87deg, #ff785c 0%, #e70a16 100%);
			border-radius: 100px;

		}
	}
}


.icon-play {
	width: 100%;
	opacity: 0;
	transition: .5s;
}

.zhezhaos {
	width: 100%;
	height: 100%;
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1;

	&::after {
		content: '';
		position: absolute;
		width: 100%;
		height: 0;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.2);
		transition: all 0.6s;
		z-index: -1;
	}
}

.webinar-sign {
	height: .50rem;
	min-height: 35px;
	max-height: 50px;
	width: 295px;
	border-radius: 50px;
	// margin-top: .6rem;
	overflow: hidden;

	.el-form {
		height: 100%;

		.el-form-item {
			margin-bottom: 0;
			height: 100%;

			.el-form-item__content {
				height: 100%;

				.flex {
					height: 100%;
				}
			}
		}
	}

	.icon-sousuo {
		display: flex;
		align-items: center;
	}

	.btn {
		// width:14.8%;
		display: flex;
		align-items: center;
		border-radius: 50px;
		padding: 0;
		padding: 0 .15rem;
		background: linear-gradient(-66deg, #e70a16 0%, #ff785c 100%);
	}

	::v-deep .el-input__inner {
		height: 100% !important;
		// padding-left: .47rem;
		border: none;
		background: none;
	}
}

.webinar-sign2 {
	.iconfont {
		padding-left: .15rem;
		display: flex;
		align-items: center;
		height: 100%;
		color: #525252;
	}
}


.video-goodss:not(:nth-child(3n)){
	margin-right: .38rem;
}
.video-goods {
	background: rgba(246, 246, 248, 1);
	border-radius: 10px;
	overflow: hidden;
	width: 31.5%;

	&:hover {
		.zhezhaos::after {
			height: 100%;
		}

		.icon-play {
			transition-delay: .3s;
			opacity: 1;
		}
	}
	.cptus{
		min-height: 2.7rem;
	}
	img {
		width: 100%;
	}

	.resouname {
		white-space: nowrap;
		/* 不换行 */
		overflow: hidden;
		text-overflow: ellipsis;
		/* 超出部分用省略号 */
	}

	.time {
		color: #b6b6b6;
	}

}

.video-biaoqian {
	margin-top: .45rem;
	border-bottom: 1px solid #E7E7E7;

	.video-biaoqian-item {
		padding: .18rem .32rem;
		position: relative;
	}

	.xactive {
		color: #E91D1D;
	}

	.xactive::after {
		content: '';
		position: absolute;
		width: 100%;
		left: 0;
		bottom: 0;
		height: 2px;
		background-color: #E91D1D;
		transition: width 0.4s ease;
	}
}



// ==========================================================================================================================================================================
// 响应式

@media screen and (max-width:767px) {
	.webinar-banner .webinar-banner1 {
		width: 98%;

		.el-carousel__arrow--left {
			left: 0;
		}

		.el-carousel__arrow--right,
		.el-notification.right {
			right: 0;
		}
	}

	.webinar-banner-neirongs {
		width: 70%;
		flex-wrap: wrap;
		padding: .4rem;

		.webinar-banner-tu {
			width: 100%;
			margin: 0;
		}
	}

	.webinar-banner .webinar-banner-neirong {
		margin: 0;
		margin-top: .2rem;
		width: 100%;
	}

	.webinar-listbox .box {
		flex-wrap: wrap;
	}

	.webinar-sign {
		width: 100%;
	}

	.webinar-sign .btn {
		padding: 0 .3rem;
	}

	.webinar-sign2 {
		width: 100%;
		margin-top: .3rem;
		flex-wrap: wrap;
		justify-content: flex-start;
		.casca {margin: .1rem;}
	}



	.video-goods {
		width: 48%;
	}

	.video-goods-playlists {
		width: 48%;
		img {
			width: 100%;
			// min-height: 2.7rem;
		}
	}
	.video-goods-playlists:not(:nth-child(3n)){
		margin-right: .1rem;
	}
	.video-goods-playlists:not(:nth-child(2n)){
		margin-right: .1rem;
	}
	.video-goodss:not(:nth-child(3n)){
		margin-right: .1rem;
	}
	.video-goodss:not(:nth-child(2n)){
		margin-right: .1rem;
	}
}
</style>